import { createCancellationPolicyService } from '@shared/api/cancellation-policy.service'
import { authorizedHttpClient } from './http-client'

export const CancellationPolicyService = createCancellationPolicyService(
  authorizedHttpClient,
  import.meta.env.VITE_API_URL,
)
